import { useEffect } from "react";
import {
  getNativeTokens,
} from "@/integrations/clients/carAuction/nativeAuth";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import {
  refreshNativeSession,
} from "@/integrations/clients/carAuction/carAuctionClient";

/**
 * Refresh native tokens when the app resumes from background (not on every mount).
 */
export function useNativeSessionRefresh() {
  const { isNative } = useNativePlatform();

  useEffect(() => {
    if (!isNative) return;

    let active = true;
    let removeListener: (() => void) | undefined;

    const refreshIfNeeded = async () => {
      const tokens = getNativeTokens();
      if (!tokens?.refreshToken) return;

      await refreshNativeSession();
    };

    void import("@capacitor/app").then(({ App }) => {
      if (!active) return;

      void App.addListener("appStateChange", ({ isActive }) => {
        if (isActive) void refreshIfNeeded();
      }).then((handle) => {
        if (!active) {
          void handle.remove();
          return;
        }
        removeListener = () => {
          void handle.remove();
        };
      });
    });

    return () => {
      active = false;
      removeListener?.();
    };
  }, [isNative]);
}
